<template>
  <div>
    <page-header
      :title="isUpdate ? 'Updating invoice' : 'Create invoice'"
      :back="true"
    />
    <div class="container new-invoice-form">
      <span class="row between">
        <h4>Customer info</h4>
        <span>
          <button class="blue icon" @click="setModalFindCustomer">
            <span>
              <font-awesome-icon icon="user" />
            </span>
            Find Customer
          </button>
        </span>
      </span>
      <form-field
        :addClass="'long'"
        label="Business name"
        :values="this.formData"
        :name="'business'"
        :onUpdate="updateField"
        :errors="errors"
      />
      <form-field
        label="First name"
        :values="this.formData"
        :name="'firstname'"
        :onUpdate="updateField"
        :errors="errors"
      />
      <form-field
        label="Last name"
        :values="this.formData"
        :name="'lastname'"
        :onUpdate="updateField"
        :errors="errors"
      />
      <form-field
        label="Phone number"
        :values="this.formData"
        name="number"
        :onUpdate="updateField"
        :errors="errors"
      />
      <form-field
        label="Email"
        :values="this.formData"
        name="email"
        :onUpdate="updateField"
        :errors="errors"
      />
      <h4>Order information</h4>
      <form-field
        label="Invoice number"
        :values="this.formData"
        name="invoice"
        :onUpdate="updateField"
        :errors="errors"
        :disabled="isUpdate"
      />

      <div>
        <label>Status</label>
        <select name="status" @input="updateField">
          <option
            v-for="(st, index) in statusFieldOptions"
            :key="st"
            :value="index + 1"
            :selected="index + 1 + '' === formData.status + ''"
          >
            {{ st }}
          </option>
        </select>
      </div>

      <form-field
        label="Date"
        :values="this.formData"
        name="orderdate"
        :type="'date'"
        :onUpdate="updateField"
        :errors="errors"
      />
      <form-field
        label="Due date"
        :values="this.formData"
        name="orderdue"
        :type="'date'"
        :onUpdate="updateField"
        :errors="errors"
      />
      <form-field
        :addClass="'long'"
        label="Description"
        :values="this.formData"
        name="descr"
        :type="'textarea'"
        :onUpdate="updateField"
        :errors="errors"
      />

      <h4>Payment</h4>
      <form-field
        label="Total"
        :values="this.formData"
        name="owe"
        :type="'number'"
        :onUpdate="updateField"
        :errors="errors"
      />
      <form-field
        label="Paid"
        :values="this.formData"
        name="paid"
        :type="'number'"
        :onUpdate="updateField"
        :errors="errors"
      />
      <form-field
        label="Payment type"
        :values="this.formData"
        name="payType"
        :onUpdate="updateField"
        :errors="errors"
      />
      <div>
        <label>Balance</label>
        <p class="balance">{{ getBalance }}</p>
      </div>
      <div class="long right p-10">
        <p v-if="formError" class='form-error'>{{ formError }}</p>
        <button class="green p-10" @click="submitForm">Submit</button>
      </div>
    </div>
  </div>
</template>

<script>
import generateInvoiceNumber from "../../utils/generateInvoiceNumber";
import CustomerList from "../../components/CustomerList";
import FormField from "../../components/FormField";
import { fMon, calc } from "../../utils/money";
import { parseDate, localParse } from "../../utils/date";
import { statuses } from "../../constants/status";
import router from '../'
import PageHeader from '../../components/PageHeader.vue';
export default {
  name: "NewInvoice",
  data: function() {
    return {
      statusFieldOptions: statuses,
      errors: {},
      formError: null,
      formData: {
        invoice: generateInvoiceNumber(),
        descr: "",
        owe: 0,
        paid: 0,
        status: "2",
        payType: '',
        business: "",
        firstname: "",
        emailCustomer: false,
        lastname: "",
        number: "",
        email: "",
        orderdate: parseDate(),
        orderdue: parseDate()
      }
    };
  },
  components: { FormField, PageHeader },
  computed: {
    getBalance() {
      return fMon(calc(this.formData.owe, this.formData.paid, "sub"));
    },
    isUpdate() {
      return this.$route.params.action === "edit";
    },
    createFromUser() {
      return (
        this.$route.params.action === "create" &&
        this.$route.params.id !== "new"
      );
    }
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    if (this.isUpdate) {
      let findInvoice = [...this.$store.getters.invoiceList].filter(
        inv => inv.invoice === this.$route.params.id
      );
      if (!(findInvoice && findInvoice.length > 0)) {
        findInvoice = [...this.$store.getters.compiledSearchResults].filter(
          inv => inv.invoice === this.$route.params.id
        );
      }
      if (findInvoice && findInvoice.length > 0) {
        const invoice = findInvoice[0];
        this.formData.invoice = invoice.invoice;
        this.formData.owe = invoice.owe;
        this.formData.paid = invoice.paid;
        this.formData.payType = invoice.payType;
        this.formData.status = invoice.status;
        this.formData.business = invoice.business;
        this.formData.firstname = invoice.firstname;
        this.formData.lastname = invoice.lastname;
        this.formData.number = invoice.number;
        this.formData.email = invoice.email;
        this.formData.descr = invoice.descr;
        this.formData.orderdate = parseDate(invoice.orderdate);
        this.formData.orderdue = parseDate(invoice.orderdue);
      }
    } else if (this.createFromUser) {
      const findCust = [...this.$store.getters.customerList.data].filter(
        cus => cus.reference + "" === this.$route.params.id + ""
      );
      if (findCust && findCust.length > 0) {
        const customer = findCust[0];
        this.formData.business = customer.business;
        this.formData.firstname = customer.firstname;
        this.formData.lastname = customer.lastname;
        this.formData.number = customer.number;
        this.formData.email = customer.email;
      }
    }
  },
  methods: {
    async submitForm() {
      let requiredItems = ['invoice', 'owe', 'paid']

      if(this.formData.emailCustomer){
        requiredItems.push('email')
      }

      const fData = { ...this.formData }
      let errors = {}

      Object.keys(fData).forEach((k) => {
        if(requiredItems.includes(k) && (!fData[k] || fData[k].replace(/\s+/g, '') === '')){
          errors[k] = 'Field is required'
          if(k === 'email' && this.formData.emailCustomer){
            errors[k] = 'Email required to send email'
          } 
        }
      })


      this.errors = errors
      if(Object.keys(errors).length < 1){
        const payload = {
          ...this.formData,
          orderdue: localParse(this.formData.orderdue),
          orderdate: localParse(this.formData.orderdate),
          formType: this.isUpdate ? 'update' : 'create'
        }
        const result = await this.$store.dispatch('submitInvoiceForm', payload)
        if(result === 'success'){
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          router.push("/");
        } else {
          this.formError = "Error submitting form"
        }
      }
    },
    setModalFindCustomer() {
      this.$store.commit("setModal", {
        component: CustomerList,
        mounted: true,
        hideGoodClick: true,
        header: "Choose customer",
        props: {
          clickCustomer: x => {
            this.formData.business = x.business;
            this.formData.firstname = x.firstname;
            this.formData.lastname = x.lastname;
            this.formData.number = x.number;
            this.formData.email = x.email;
            this.$store.commit("setModal", null);
          }
        }
      });
    },
    updateField(e) {
      if(e.target && e.target.id && e.target.id === 'emailCustomer'){
        this.formData['emailCustomer'] = !this.formData['emailCustomer']
      } else {
        this.formData[e.target.name] = e.target.value;
      }
    }
  }
};
</script>

<style lang="scss">
@import "../../styles/colors.scss";
@import "../../styles/vars.scss";
.new-invoice-form {
  padding-bottom: 16px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  background-color: #fff;
  width: 96%;
  margin: 10px auto 50px auto;
  .form-error {
    color: red;
    font-weight: bold;
  }
  h4 {
    width: 96%;
    font-size: 1.3rem;
    color: $maroon;
    margin: 31px 0 5px 0;
  }

  & > span.between {
    width: 96%;
    display: flex;
    justify-content: space-between;
    button {
      width: 185px;
      margin-top: 20px;
      padding-right: 12px;
    }
    h4 {
      width: auto;
    }
  }
  & > div {
    width: 48%;
    label {
      display: block;
      width: 100%;
      font-weight: bold;
      margin-bottom: 13px;
      margin-top: 20px;
      color: rgb(161, 161, 161);
    }
    .check-box {
      margin-top: 15px;
      width: 100%;
      display: flex;
      align-content: center;
      label {
        cursor: pointer;
        width: auto;
      }
      input[type="checkbox"] {
        cursor: pointer;
        display: block;
        margin: 22px 10px 0 0;
      }
    }
    input[type="text"],
    input[type="number"],
    input[type="date"],
    select,
    textarea {
      box-shadow: 0 0 0 1px rgb(117, 197, 228);
      padding: 13px 10px;
      border-radius: 4px;
      background-color: rgb(240, 251, 255);
      width: calc(96% - 20px);
      transition: all 0.5s;
      &:focus {
        background-color: rgb(217, 243, 252);
        box-shadow: 0 0 0 1px rgb(41, 155, 201);
      }
      
      &:disabled {
        background-color: rgb(235, 235, 235);
        box-shadow: 0 0 0 1px rgb(192, 192, 192);
        color: gray;
      }
    }
    input[type="date"] {
      padding: 10px 10px;
    }
    select {
      margin: 0;
      width: calc(100% - 20px);
      padding: 12px 0 11px 10px;
    }
    textarea {
      height: 90px;
      line-height: 1.75rem;
    }
  }
  & .long {
    width: 96%;
    input[type="text"],
    textarea {
      border-radius: 4px;
      width: calc(98% - 20px);
    }
  }
  .balance {
    font-size: 2rem;
    color: $green;
    font-weight: bold;
    margin: 16px 0 0 0;
  }
  @media screen and (max-width: 460px) {
    & > div {
      width: 96%;
    }
  }
  .hasError {
    & input[type="text"],
    & input[type="number"],
    & input[type="date"],
    & select,
    & textarea {
      box-shadow: 0 0 0 1px rgb(228, 117, 117);
      background-color: rgb(255, 240, 247);
    }
    label {
      color: red;
    }
  }
}
.field-error {
  font-style: italic;
  padding: 2px 8px;
  display: inline-block;
  color: red;
  margin-top: 8px;
  border-radius: 5px;
  margin-left: 5px;
  color: #fff;
  background-color: red;
}
</style>
